import { Navigate } from 'react-router-dom';
import type { ReactNode } from 'react';
import { useIsAuthenticated, useAuthLoading } from '../store/slices/authSlice';

interface ProtectedRouteProps {
    children: ReactNode;
}

/**
 * Protected route wrapper that redirects to login if not authenticated
 */
export default function ProtectedRoute({ children }: ProtectedRouteProps) {
    const isAuthenticated = useIsAuthenticated();
    const loading = useAuthLoading();

    // Show loading state while checking authentication
    if (loading === 'loading') {
        return (
            <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-[#f8fafc] to-[#e0e7ff]">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#6e64f0]"></div>
            </div>
        );
    }

    // Redirect to login if not authenticated
    if (!isAuthenticated) {
        return <Navigate to="/login" replace />;
    }

    return <>{children}</>;
}
